/*********************
 Nav Desktop
 *********************/

//hover mouse over
document.querySelectorAll(".navDesktopNested").forEach(function (element) {
    element.addEventListener("mouseover", function () {
        this.previousElementSibling.classList.add("fakeHover");
    });
});

//hover mouse leave
document.querySelectorAll(".navDesktopNested").forEach(function (element) {
    element.addEventListener("mouseleave", function () {
        this.previousElementSibling.classList.remove("fakeHover");
    });
});

/*********************
 Nav Mobile
 *********************/

function openNav() {
    document.querySelector("#navMobileSlider").classList.add("open");
    document.querySelector("body").classList.add("overlay");
}

function closeNav() {
    document.querySelector("#navMobileSlider").classList.remove("open");
    document.querySelector("body").classList.remove("overlay");
}

//open menu
document.querySelector("#navMenu").addEventListener("click", function () {
    //check if search is open
    if (document.querySelector("#searchOverlay").classList.contains("open")) {
        closeSearch();
        setTimeout(function () {
            openNav();
        }, 500);
    } else {
        openNav();
    }
});

//close menu
document.querySelector("#navMobileExit").addEventListener("click", closeNav);

//nested menu
document.querySelectorAll(".navMobileBodyLink.dropdown").forEach(function (element) {
    element.addEventListener("click", function () {
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            this.nextElementSibling.removeAttribute("style");
        } else {
            //check for existing
            if (document.querySelector(".navMobileBodyLink.dropdown.active")) {
                document.querySelector(".navMobileBodyLink.dropdown.active").classList.remove("active");
                document.querySelector(".navMobileBodyNested[style]").removeAttribute("style");
                document.querySelector("#navMobileBody").scroll({
                    top: 0,
                    behavior: "smooth"
                });
            }
            this.classList.add("active");
            this.nextElementSibling.style.height = `${this.nextElementSibling.scrollHeight}px`;

        }
    });
});

/*********************
 Nav General
 *********************/

//navCart check if quanitty is zero on load
if (document.querySelector(".totalCountCircle").textContent != "0") {
    document.querySelectorAll(".totalCountCircle").forEach(function (element) {
        element.classList.add("active");
    });
}
